export default {
      id: "helpcenter-usage",
      viewBox: "0 0 934.98 571.14",
      url: __webpack_public_path__ + "icons.svg#helpcenter",
      toString: function () {
        return this.url;
      }
    }